<template>
  <div :class="{ 'show': show, 'pointer-events-none': !show, 'variables-panel': !fixed }">
    <div class="flex items-center justify-between !bg-secondary !p-2 !rounded-xs" v-if="!fixed">
      <summary class="!text-white !font-semibold !min-h-[20px]">
        Placeholders ({{ variables.length }}): 
        <span class="!badge !badge-xs !badge-primary !mx-1" v-for="variable in variables" :key="variable">
          {{ variable }}
        </span>
      </summary>
    </div>
    
    <div class="text-sm !p-4 !overflow-scroll !h-[70%]">
      <p class="!my-0 !text-gray-500 !font-light !text-xs">Placeholders will be replaced with values below on use.</p> 
      
      <!-- Variables section -->
      <fieldset class="!fieldset !border-none" v-if="variables.length > 0">
        <div class="!grid !grid-cols-1 !gap-2 !mt-2">
          <div v-for="variable in variables" :key="variable" class="!form-control">
            <label class="!label !text-content-secondary !text-xs">
              <span class="!text-black !opacity-80">{{ variable.charAt(0).toUpperCase() + variable.slice(1) }} :</span>
            </label>
            <input 
              type="text" 
              :placeholder="variable + ' Value here'" 
              v-model="variableValues[variable]" 
              class="!input !input-bordered !w-full !placeholder-gray-400 !text-black !bg-transparent !border-1  smartpress-disabled" 
            />
          </div>
        </div>
      </fieldset>
      
      <!-- Preview section -->
      <fieldset class="!fieldset !mt-4 !border-none" v-if="variables.length > 0">
        <legend class="!text-black !opacity-80">Preview:</legend>
        <div class="!p-4 !bg-base-200 !rounded-box !whitespace-pre-wrap !text-black" v-html="previewContentWithText"></div>
      </fieldset>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VariablesPanel',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    variables: {
      type: Array,
      default: () => []
    },
    prompt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      variableValues: {}
    };
  },
  computed: {
    previewContent() {
      let content = this.prompt;
      
      // Replace each variable with its value or keep the placeholder if no value
      this.variables.forEach(variable => {
        const regex = new RegExp(`\\{\\{\\s*${variable}\\s*\\}\\}`, 'g');
        const value = this.variableValues[variable] || `{{ ${variable} }}`;
        content = content.replace(regex, value);
      });
      
      return content;
    },
    previewContentWithText() {
      let content = this.previewContent;
      
      // Replace all HTML tags with their text equivalents
      const htmlTagRegex = /<\/?[^>]+(>|$)/g;
      content = content.replace(htmlTagRegex, (match) => {
        return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      });

      // Replace variables with highlighted spans
      this.variables.forEach(variable => {
        const regex = new RegExp(`\\{\\{\\s*${variable}\\s*\\}\\}`, 'g');
        content = content.replace(regex, `<span class="bg-green-200">{{ ${variable} }}</span>`);
      });

      return content;
    }
  },
  methods: {
    getProcessedPrompt() {
      return this.previewContent;
    }
  },
  watch: {
    variables: {
      handler(newVars) {
        // Create a new object with only the current variables
        const newVariableValues = {};
        
        // Add all current variables (keep existing values)
        newVars.forEach(variable => {
          newVariableValues[variable] = this.variableValues[variable] || '';
        });
        
        // Replace the entire object with the new one
        this.variableValues = newVariableValues;
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.variables-panel {
  position: absolute;
  top: 0;
  left: 300px;
  width: 300px;
  height: 100%;
  background: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  border-radius: 8px;
  overflow: hidden;
  z-index: -1;
  opacity: 0;
  transform: translateX(-100%);
}

.variables-panel.show {
  transform: translateX(50px);
  opacity: 1;
}

.templates-header {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(45deg, #0a0909, #3d0418) !important;
  position: sticky;
  top: 0;
  z-index: 1;
}

.pointer-events-none {
  pointer-events: none;
}
</style> 